import React from 'react';

// ─── Message Helpers ──────────────────────────────────────────────────────────
const URL_REGEX = /(https?:\/\/[^\s<>"')\]]+)/g;

function MessageContent({ text, isHost }) {
  if (!text) return null;
  const parts = text.split(URL_REGEX);
  return (
    <span>
      {parts.map((part, i) =>
        URL_REGEX.test(part)
          ? <a key={i} href={part} target="_blank" rel="noopener noreferrer"
              style={{ color: isHost ? '#c8a84b' : '#1a6b3a', textDecoration:'underline', wordBreak:'break-all' }}>{part}</a>
          : <span key={i}>{part}</span>
      )}
    </span>
  );
}

export { URL_REGEX };
export default MessageContent;
